module.exports = __webpack_public_path__ + "static/media/QualtricsXM_Step2_Image19.aaf3cc85.webp";